/* global propel */
import { __ } from '@wordpress/i18n';
import throttle from 'lodash-es/throttle.js';
import sanitizeHTML from 'propel/sanitizeHTML';

const propelInit = function() {
const liveSearchElements = document.querySelectorAll('.predictive-search');

const initializeLiveSearchForm = (liveSearchElement) => {
	const form = liveSearchElement.querySelector('.predictive-search__form');
	const input = liveSearchElement.querySelector('.predictive-search__input');

	const results = liveSearchElement.querySelector(
		'.predictive-search__results'
	);
	const closeButton = liveSearchElement.querySelector(
		'.predictive-search__close'
	);

	if (!form || !input || !results || !closeButton) {
		return;
	}

	const searchUrl = `${window.propel.siteUrl}/wp-json/wp/v2/search?per_page=3&propel_search_card=1`;

	const fetchResults = async (query) => {
		input.setAttribute('aria-expanded', 'true');
		results.classList.add('predictive-search__results--loading');

		try {
			const response = await fetch(`${searchUrl}&search=${query}`);
			const data = await response.json();
			const totalResults = response.headers.get('X-WP-Total');

			results.innerHTML = '';

			if (0 === data.length) {
				const noResultsMessage = document.createElement('div');
				noResultsMessage.classList.add('predictive-search__no-results');
				noResultsMessage.textContent = __('No results found', 'propel');
				results.appendChild(noResultsMessage);
			} else {
				const resultsHeading = document.createElement('h2');
				resultsHeading.classList.add('predictive-search__heading');
				resultsHeading.textContent = __('Results', 'propel');
				results.appendChild(resultsHeading);

				data.forEach((item) => {
					if (!item.url || !item.title || !item.card) {
						return;
					}

					const cardWrapper = document.createElement('div');
					cardWrapper.innerHTML = sanitizeHTML(item.card);

					const resultCard = cardWrapper.firstElementChild;

					if (!resultCard) {
						return;
					}

					resultCard.setAttribute('role', 'option');
					results.appendChild(resultCard);
				});

				if (totalResults > 3) {
					const viewMoreLink = document.createElement('a');
					viewMoreLink.href = `${window.propel.siteUrl}/?s=${query}`;

					viewMoreLink.classList.add(
						'predictive-search__view-more-link'
					);

					const viewMoreText = document.createElement('span');
					viewMoreText.textContent = __('All results', 'propel');
					viewMoreLink.appendChild(viewMoreText);
					results.appendChild(viewMoreLink);
				}
			}

			liveSearchElement.classList.add('predictive-search--active');
			results.classList.add('predictive-search__results--active');
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error(
				__('Error fetching search results:', 'propel'),
				error
			);

			const errorMessage = document.createElement('p');

			errorMessage.textContent = __(
				'Error fetching search results. Please try again later.',
				'propel'
			);

			results.appendChild(errorMessage);
			liveSearchElement.classList.add('predictive-search--active');
			results.classList.add('predictive-search__results--active');
		} finally {
			results.classList.remove('predictive-search__results--loading');
		}
	};

	const clearResults = () => {
		results.innerHTML = '';
		liveSearchElement.classList.remove('predictive-search--active');
		results.classList.remove('predictive-search__results--active');
		input.setAttribute('aria-expanded', 'false');
		input.value = '';
	};

	input.addEventListener(
		'input',
		throttle(() => {
			if (input.value.length > 2) {
				fetchResults(input.value);
			}
		}, 1000)
	);

	closeButton.addEventListener('click', clearResults);
};

if (liveSearchElements.length > 0 && propel.siteUrl) {
	liveSearchElements.forEach((liveSearchElement) => {
		initializeLiveSearchForm(liveSearchElement);
	});
}

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['predictive-search'] = window.propel.blocks['predictive-search'] || {};
window.propel.blocks['predictive-search'].script = propelInit;
